import store from '../store'
import axios from 'axios'
import { RESPONSE_MESSAGES } from '../config'
import config from '../config';

const internals = {}



internals.get = function(url, params, options) {
  let config = {
    method: 'GET',
    url: url,
    params: params
  }
  config = Object.assign(config, options)
  return axios(config)
    .then(function(response) {

      if (response.headers['x-access-token']) {
        internals.updateTokens(response.headers)
      }
      return response
    })
    .catch(function(error) {
      if (error === RESPONSE_MESSAGES.EXPIRED_ACCESS_TOKEN) { 
        store.dispatch('auth/useRefreshToken')
        return internals.get(url, params, options)
      } else {
        throw error
      }
    })
}

internals.trip_get = function(url, params, options) {
  let configData = {
    method: 'GET',
    url: config.trip_serverURI + url,
    params: params
  }
  configData = Object.assign(configData, options)
  return axios(configData)
    .then(function(response) {
      if (response.headers['x-access-token']) {
        internals.updateTokens(response.headers)
      }
      return response
    })
    .catch(function(error) {
      if (error === RESPONSE_MESSAGES.EXPIRED_ACCESS_TOKEN) { 
        store.dispatch('auth/useRefreshToken')
        return internals.get(url, params, options)
      } else {
        throw error
      }
    })
}

internals.put = function(url, payload, options, headers) {
  let config = {
    method: 'PUT',
    url: url,
    data: payload,
    headers
  }
  config = Object.assign(config, options)
  return axios(config)
    .then(function(response) {
      if (response.headers['x-access-token']) {
        internals.updateTokens(response.headers)
      }
      return response
    })
    .catch(function(error) {
      if (error === RESPONSE_MESSAGES.EXPIRED_ACCESS_TOKEN) {
        store.dispatch('auth/useRefreshToken')
        return internals.put(url, payload, options)
      } else {
        throw error
      }
    })
}


internals.trip_put = function(url, payload, options, headers) {
  let configData = {
    method: 'PUT',
    url: config.trip_serverURI + url,
    data: payload,
    headers
  }
  configData = Object.assign(configData, options)
  return axios(configData)
    .then(function(response) {
      if (response.headers['x-access-token']) {
        internals.updateTokens(response.headers)
      }
      return response
    })
    .catch(function(error) {
      if (error === RESPONSE_MESSAGES.EXPIRED_ACCESS_TOKEN) { 
        store.dispatch('auth/useRefreshToken')
        return internals.get(url, payload, options)
      } else {
        throw error
      }
    })
}


internals.post = function(url, payload, options) {
  let config = {
    method: 'POST',
    url: url,
    data: payload
  }
  config = Object.assign(config, options)
  return axios(config)
    .then(function(response) {
      if (response.headers['x-access-token']) {
        internals.updateTokens(response.headers)
      }
      return response
    })
    .catch(function(error) {
      if (error === RESPONSE_MESSAGES.EXPIRED_ACCESS_TOKEN) {
        store.dispatch('auth/useRefreshToken')
        return internals.post(url, payload, options)
      } else {
        throw error
      }
    })
}

internals.trip_post = function(url, payload, options) {
  let configData = {
    method: 'POST',
    url: config.trip_serverURI + url,
    data: payload
  }
  configData = Object.assign(configData, options)
  return axios(configData)
    .then(function(response) {
      if (response.headers['x-access-token']) {
        internals.updateTokens(response.headers)
      }
      return response
    })
    .catch(function(error) {
      if (error === RESPONSE_MESSAGES.EXPIRED_ACCESS_TOKEN) { 
        store.dispatch('auth/useRefreshToken')
        return internals.get(url, payload, options)
      } else {
        throw error
      }
    })
}

internals.delete = function(url, payload, options) {
  let config = {
    method: 'DELETE',
    url: url,
    data: payload
  }
  config = Object.assign(config, options)
  return axios(config)
    .then(function(response) {
      if (response.headers['x-access-token']) {
        internals.updateTokens(response.headers)
      }
      return response
    })
    .catch(function(error) {
      if (error === RESPONSE_MESSAGES.EXPIRED_ACCESS_TOKEN) {
        store.dispatch('auth/useRefreshToken')
        return internals.delete(url, payload, options)
      } else {
        throw error
      }
    })
}

internals.updateTokens = function(headers) {
  const tokens = {
    accessToken: headers['x-access-token'],
    refreshToken: headers['x-refresh-token']
  }
  store.dispatch('auth/updateTokens', tokens)
}
internals.fetchTraccarSession=function(url, params, options){
  let config = {
    method: 'GET',
    url: url,
    params: params
  }
  config = Object.assign(config, options)
  axios.defaults.headers.common.Authorization = undefined
  return axios(config)
    .then(function(response) {

      if (response.headers['x-access-token']) {
        internals.updateTokens(response.headers)
      }
      return response
    })
    .catch(function(error) {
      if (error === RESPONSE_MESSAGES.EXPIRED_ACCESS_TOKEN) { 
        store.dispatch('auth/useRefreshToken')
        return internals.get(url, params, options)
      } else {
        throw error
      }
    })
}

export default internals



// WEBPACK FOOTER //
// ./src/services/http-client.service.js